export default () => ({
    fundraiserData: null,
    projectData: null,
    stepsValidationState: {},
    stepsTouched: [],
    donorData: {},
    formSelectChoices: {},
    currentStep: "donationAmount",
    donationData: {
        donorContactData: {
            type: 1,
            firstname: null,
            lastname: null,
            email: null,
            countryId: 'DEU',
            zipValue: null,
            cityId: null,
            cityValue: null,
            streetId: null,
            streetValue: null,
            houseNumber: null,
            isPostbox: false,
            postboxNumber: null,
            salutation: null,
            phone: null
        },
        paymentData: {
            paymentType: null,
            iban: null,
            accountHolder: null
        },
        donationAmount: "",
        coveredFees: "",
        acceptFees: false,
        noAppreciation: false,
        sendDonationReceipt: true
    },
    projectIsLoaded: false,
    donationFinishedSuccessful: false
})
